import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import '../../HTMLIntro.css'; // Reusing the same CSS file

const ReactCourseOutline = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const courseSections = [
    { id: 'history', title: 'History and Purpose of ReactJS', path: '/react-history-and-purpose-of-reactjs' },
    { id: 'environment', title: 'Setting Up React Environment', path: '/react-setting-up-react-environment' },
    { id: 'jsx', title: 'Understanding JSX', path: '/react-understandingjsx' },
    { id: 'component', title: 'React Component', path: '/react-component' },
    { id: 'architecture', title: 'React Project Architecture', path: '/react-project-architecture' },
    { id: 'state', title: 'State Management', path: '/react-state-management' },
    { id: 'importing', title: 'Importing Files', path: '/react-importing-files' },
    { id: 'router', title: 'React Router', path: '/react-router' },
    { id: 'styling', title: 'Styling Component', path: '/react-styling-component' },
    { id: 'bootstrap', title: 'React Bootstrap', path: '/react-bootstrap' },
    { id: 'conditional', title: 'Conditional Rendering', path: '/react-conditional-rendering' },
    { id: 'lifecycle', title: 'Lifecycle Method', path: '/react-lifecycle-method' },
    { id: 'hooks', title: 'React Hooks', path: '/react-hooks' }
  ];

  return (
    <HTMLCourseNavProvider>
      <div className="modern-course-container">
        <SideBar />
        
        <div className="course-content">
          <div className="course-header">
            <h1 className="course-title">React Course</h1>
            <p className="course-subtitle">Build modern user interfaces with the powerful React library</p>
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '0%' }}></div>
              </div>
              <span className="progress-text">0% Complete</span>
            </div>
          </div>

          <div className="course-outline-card">
            <div className="card-header">
              <h2 className="card-title">
                <i className="fab fa-react me-2"></i>
                Course Outline
              </h2>
              <span className="lesson-count">{courseSections.length} lessons</span>
            </div>

            <div className="lessons-container">
              {courseSections.map((section, index) => (
                <div key={section.id} className="lesson-section">
                  <div 
                    className={`lesson-item ${expandedSections[section.id] ? 'expanded' : ''}`}
                    onClick={() => section.sublessons && toggleSection(section.id)}
                  >
                    <div className="lesson-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    <div className="lesson-content">
                      <Link 
                        to={section.path} 
                        className="lesson-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {section.title}
                      </Link>
                      
                      {section.sublessons && (
                        <button className="expand-btn">
                          <i className={`fas fa-chevron-${expandedSections[section.id] ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                    </div>

                    <div className="lesson-status">
                      <span className="status-badge">Start</span>
                    </div>
                  </div>

                  {section.sublessons && expandedSections[section.id] && (
                    <div className="sublessons-container">
                      {section.sublessons.map((sublesson, subIndex) => (
                        <Link 
                          key={subIndex} 
                          to={sublesson.path} 
                          className="sublesson-item"
                        >
                          <div className="sublesson-number">
                            {index + 1}.{subIndex + 1}
                          </div>
                          <span className="sublesson-title">{sublesson.title}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="card-footer">
              <button className="start-course-btn">
                <i className="fas fa-atom me-2"></i>
                Start Building with React
              </button>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
};

export default ReactCourseOutline;